import { put, takeLatest, select, call } from 'typed-redux-saga/macro';
import { attachmentsActionTypes } from '../ducks/attachments';
import TStore from '../../types/store';
import { TMessage } from '../../types/rooms';
import { TAttachmentDB } from '../../types/db';
import { AttachmentModel } from '../../lib/db';

function* getAttachmentsRequest({ payload }: any) {
  yield put({
    type: attachmentsActionTypes.SET_LOADING,
    payload: true,
  });

  try {
    let messages: TMessage[] = [];
    const attachments: TAttachmentDB[] = [];
    if (payload === 'ROOM') {
      messages = yield select((store: TStore) => store.rooms.messages);
    } else {
      messages = yield select((store: TStore) => store.directChat.messages);
    }

    console.log('MM', messages);

    for (const message of messages) {
      if (message.attachment && message.attachment.id) {
        const attachmentDB = yield* call(AttachmentModel.processAttachment, {
          ...message.attachment,
          id: message.attachment.id || '',
          blob: null,
        });
        attachments.push(attachmentDB);
      }
    }
    console.log('attachments', attachments);
    yield put({
      type: attachmentsActionTypes.GET_ATTACHMENTS_SUCCESS,
      payload: attachments,
    });
  } catch {}

  yield put({
    type: attachmentsActionTypes.SET_LOADING,
    payload: false,
  });
}

function* attachments() {
  yield takeLatest(attachmentsActionTypes.GET_ATTACHMENTS_REQUEST, getAttachmentsRequest);
}

export default attachments;
